import React, { useEffect } from "react";
import $ from "jquery";

const SideMenuBottom = () => {
  // useEffect(() => {
  //   // Update the document title using the browser API
  //   $("#hide_menu").on("click", function () {
  //     $("#menu-left").css({ width: "9%" });
  //     $("#content-mid").css({ width: "86%" });
  //     //$('#example_info').css('left','161px');
  //     $(".left-menu a").css({
  //       "font-size": "0px",
  //       padding: "10px 30px",
  //       width: "70px",
  //     });
  //     $("#hide_menu, #show_menu").toggle();
  //   });
  //
  //   $("#show_menu").on("click", function () {
  //     $("#menu-left").css({ width: "20%" });
  //     $("#content-mid").css({ width: "75%" });
  //     //$('#example_info').css('left','300px');
  //     $(".left-menu a").css({
  //       "font-size": "18px",
  //       padding: "10px 25px 10px 70px",
  //       width: "auto",
  //     });
  //     $("#hide_menu, #show_menu").toggle();
  //   });
  // });
  function hide(){
    $("#menu-left").css({ width: "9%" });
    $("#content-mid").css({ width: "86%" });
    //$('#example_info').css('left','161px');
    $(".left-menu a").css({
      "font-size": "0px",
      padding: "10px 30px",
      width: "70px",
    });
    $("#hide_menu, #show_menu").toggle();
    $(".tree").attr("hidden", "true");
  }

  function show(){
    $("#menu-left").css({ width: "20%" });
    $("#content-mid").css({ width: "75%" });
    //$('#example_info').css('left','300px');
    $(".left-menu a").css({
      "font-size": "18px",
      padding: "10px 25px 10px 70px",
      width: "auto",
    });
    $("#hide_menu, #show_menu").toggle();
    $(".tree").removeAttr("hidden");
  }
  return (
    <div>
      <a href="javascript:void(0)" className="show-hide-Menu" id="hide_menu" onClick={hide}>
        Verberg
      </a>
      <a href="javascript:void(0)" className="show-hide-Menu" id="show_menu" onClick={show}>
        Toon
      </a>
    </div>
  );
};

export default SideMenuBottom;
